export const isDemonstrationStartedSubtype = (subtype?: string) =>
    Boolean(subtype?.startsWith('NOTIFY_BROADCAST_') && subtype.includes('DEMO') && subtype.includes('START'));
